export function processButtons(base = document) {
}